export default {
  trayTitle: 'Last 24 Hours',
};
